<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import EquipmentPager from './EquipmentPager.vue';
import './equipment-ui.css';

defineProps<{
  count: number;
  total: number;
  pageCount: number;
  isLoading: boolean;
  isError: boolean;
  emptyIcon: string;
}>();
defineEmits<{ retry: [] }>();
const page = defineModel<number>('page', { required: true });
const pageSize = defineModel<number>('pageSize', { required: true });

const { t } = useI18n({ useScope: 'global' });
</script>

<template>
  <div class="eqs">
    <div class="eqs__toolbar eq-card"><slot name="toolbar" /></div>

    <section class="eq-card">
      <div v-if="isLoading" class="eq-state">
        <i class="pi pi-spin pi-spinner" />
        <p>{{ t('equipment.loading') }}</p>
      </div>
      <div v-else-if="isError" class="eq-state" role="alert">
        <i class="pi pi-exclamation-circle" />
        <p>{{ t('equipment.loadError') }}</p>
        <button type="button" class="eq-btn" @click="$emit('retry')">
          {{ t('equipment.retry') }}
        </button>
      </div>
      <div v-else-if="!count" class="eq-state">
        <i class="pi" :class="emptyIcon" />
        <p>{{ t('equipment.empty') }}</p>
      </div>
      <div v-else class="eq-table-wrap"><slot /></div>
      <EquipmentPager
        v-model:page="page"
        v-model:page-size="pageSize"
        :page-count="pageCount"
        :total="total"
      />
    </section>
  </div>
</template>

<style scoped>
.eqs {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.eqs__toolbar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  align-items: end;
  gap: 0.85rem;
  padding: 1rem 1.15rem;
}
.eqs__toolbar :deep(.eqs__wide) {
  grid-column: span 2;
}
@media (max-width: 640px) {
  .eqs__toolbar :deep(.eqs__wide) {
    grid-column: auto;
  }
}
</style>
